// src/lib/checklist-lecture.js
//
// ⚠️ UN CHAMP SE LIT D'UNE SEULE MANIÈRE (règle Dimitri 2026-08-22).
//
// `menage_runs.items_checked` était lu de DEUX façons incompatibles dans le
// même espace propriétaire :
//   · l'Accueil le prenait pour une LISTE (`Array.isArray(...) → .length`) ;
//   · la page Ménages le lit comme un OBJET par pièce (la bonne).
// Mesure en base le 2026-08-22 : la forme réelle est toujours l'objet
// (`{"sdb": ["sdb_lavabo", …], "salon": []}`). Conséquence du désaccord : le
// segment « 18 points sur 18 » de l'Accueil ne s'affichait JAMAIS.
//
// DEUX FORMES vivent en base (cf. ChecklistRunModal) :
//   · par pièce  { pieceId: [itemId, …] } — une pièce au tableau VIDE = une
//     ligne renseignée mais NON cochée ;
//   · legacy booléenne { item: true|false } — 1 ligne par item.
// Ce module est la SEULE lecture : tout écran qui compte des points passe ici.
//
// 0 montant, 0 donnée voyageur.

/**
 * Compte les points d'un `items_checked`, quelle que soit sa forme.
 * @returns {{coches:number, total:number}} total = lignes RENSEIGNÉES.
 */
export function compterPoints(itemsChecked) {
  const items = itemsChecked && typeof itemsChecked === 'object' && !Array.isArray(itemsChecked)
    ? itemsChecked : {}
  let coches = 0
  let total = 0
  for (const valeur of Object.values(items)) {
    if (Array.isArray(valeur)) {
      if (valeur.length === 0) total += 1
      else { total += valeur.length; coches += valeur.length }
    } else if (typeof valeur === 'boolean') {
      total += 1
      if (valeur) coches += 1
    }
  }
  return { coches, total }
}

/**
 * Nombre de lignes CONFIGURÉES sur le logement, depuis son template de
 * checklist (`[{ id, name, items: [{id,label}] }]`). Sert à distinguer les
 * deux vides : aucune ligne configurée (trou de paramétrage) ≠ configurée
 * mais rien coché (manquement). Mesure prod 2026-08-22 : 11 logements sur 12
 * n'ont AUCUNE checklist configurée.
 */
export function compterConfigurees(template) {
  if (!Array.isArray(template)) return 0
  return template.reduce((n, piece) => n + (Array.isArray(piece?.items) ? piece.items.length : 0), 0)
}

/**
 * LA PHRASE COMMUNE — la même dans tous les espaces (orchestrateur, proprio).
 *   · aucune ligne configurée → « Aucune checklist pour ce logement. »
 *   · configurée, rien coché  → « Checklist non remplie — 0 sur 18. »
 *   · sinon                   → « 2 sur 18 · 16 lignes non cochées »
 * `configurees = 0` avec des points cochés (template non servi) : on retombe
 * sur le total renseigné plutôt que d'affirmer une absence fausse.
 */
export function phraseChecklist(itemsChecked, configurees = 0) {
  const { coches, total } = compterPoints(itemsChecked)
  const denominateur = Math.max(Number(configurees) || 0, total)
  if (denominateur === 0) return 'Aucune checklist pour ce logement.'
  if (coches === 0) return `Checklist non remplie — 0 sur ${denominateur}.`
  const manquantes = denominateur - coches
  if (manquantes <= 0) return `${coches} sur ${denominateur} · tout est coché`
  return `${coches} sur ${denominateur} · ${manquantes} ligne${manquantes > 1 ? 's' : ''} non cochée${manquantes > 1 ? 's' : ''}`
}
